module.exports = __webpack_public_path__ + "7d02e74d71130f2a882d365da3770fc6.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/11/vinsider_sporthalsa.png
// module id = 236
// module chunks = 0